export default "__VITE_ASSET__DxARrs8o__"